import styled from '@emotion/styled';
import { ContentWrapper, fontSize } from '@styles/globalStyles';
import { breakpoint } from '@styles/breakpoints';

export const Container = styled.section`
  padding: 72px 0 120px 0;

  h2 {
    margin-bottom: 72px;
    font-weight: 400;
  }

  @media only screen and ${breakpoint.lg} {
    padding: 32px 0;

    h2 {
      margin-bottom: 20px;
      font-size: ${fontSize(24)};
    }
  } ;
`;
export const Wrapper = styled(ContentWrapper)`
  @media only screen and (max-width: 1350px) {
    padding: 0 15px;
  } ;
`;

export const Content = styled.div`
  display: flex;
  gap: 120px;

  span {
    font-weight: bold;
  }

  a {
    font-size: ${fontSize(15)};
  }

  @media only screen and ${breakpoint.lg} {
    & img {
      display: none;
    }
  } ;
`;

export const InformationWrapper = styled.div`
  width: 50%;

  a,
  a:active {
    display: inline;
    color: #009fe3;
    font-weight: 500;
    line-height: 2.14;
    letter-spacing: -0.21px;
    text-decoration: underline;
  }

  @media only screen and ${breakpoint.xl} {
    width: 100%;
  }
`;

export const Information = styled.div`
  max-width: 530px;
  font-size: ${fontSize(16)};
  font-weight: 400;
  line-height: 1.71;
  letter-spacing: -0.21px;
  text-align: left;
  color: #00202d;

  @media only screen and ${breakpoint.lg} {
    max-width: unset;
  } ;
`;

export const ImageWrapper = styled.div`
  width: 50%;

  @media only screen and ${breakpoint.lg} {
    display: none;
  } ;
`;
